module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".action-properties-accordion">' +
__e( panelName ) +
'</legend>\n    <div class="action-properties-accordion collapse collapse-target">\n        <div>\n            <div class="actions-region"></div>\n            ';
 if (showEffects) { ;
__p += '\n                <div class="effects-region"></div>\n            ';
 } ;
__p += '\n        </div>\n        <div>\n            <div class="onloads-region"></div>\n        </div>\n    </div>\n</fieldset>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/ActionPropertiesView.tpl
// module id = 1753
// module chunks = 0